import React from 'react';
import Flexbox from 'flexbox-react';
import { Route, Switch, withRouter } from "react-router-dom";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { connect } from 'react-redux';
import Popup from "./../Popup";

const mapStateToProps = ({ popup: { list } }) => {
	return {
		list,
	};
};

export default connect(mapStateToProps)(({ list }) => (
	<TransitionGroup className='PopupWrapper' style={{ pointerEvents: list.length ? 'all' : 'none' }}>
		{list.map((data, i) => {
			return (
				<CSSTransition
					classNames='popup'
					key={`popup_${i}`}
					timeout={{
						enter: 500,
						exit: 500
					}}>
					<Flexbox
						className='PopupFader'
						justifyContent='center'
						alignItems='center'
						onWheel={(e) => e.preventDefault()}>
						<Popup type={data.type}/>
					</Flexbox>
				</CSSTransition>
			);
		})}
	</TransitionGroup>
));


// WEBPACK FOOTER //
// ./src/components/PopupWrapper/PopupWrapper.js